module.exports = __webpack_public_path__ + "img/rinsizeMeasurement.b498636.jpg";